const translations = {
    addressOneFieldLabel: 'Address One',
    addressTwoFieldLabel: 'Address Two',
    cityFieldLabel: 'City',
    stateFieldLabel: 'State',
    zipCodeFieldLabel: 'Zip Code'
};

export default translations;
